import './../../scss/blocks/_bgcircles.scss'

document.addEventListener('DOMContentLoaded', () => {
    const bgcirclesList = document.querySelectorAll('.bgcircles')
    const site = document.querySelector('.site')

    if (bgcirclesList.length > 0 && site) {
        for (let i = bgcirclesList.length - 1; i >= 0; i--) {
            site.insertBefore(bgcirclesList[i], site.firstChild)
        }
    }
})
